import { OptionType } from "../../shared/components/BaseAsyncPaginate";
import { createLoadOptions } from "../../service/createLoadOptions";
import { getPaginatedByNameTerritoryManagers } from "./territory-manager-service";
import {
  GetTerritoryManagersResponse,
  TerritoryManager,
} from "../models/response/get-territory-managers-response";

const fetchTerritoryManagers = async (
  page: number,
  perPage: number,
  searchQuery?: string
): Promise<GetTerritoryManagersResponse> => {
  return getPaginatedByNameTerritoryManagers({ page, perPage, searchQuery });
};

const territoryManagersMapper = (spec: TerritoryManager): OptionType => ({
  value: spec.id,
  label: spec.name,
});

export const loadTerritoryManagers = createLoadOptions(
  fetchTerritoryManagers,
  territoryManagersMapper
);
